// extracted by mini-css-extract-plugin
module.exports = {"root":"fifth_root__1fvoG","check":"fifth_check__1hxig"};